export default function splitSeparatedValue(value: string, separator: string = ',') {
  return value
    .split(separator)
    .map((s) => s.trim())
    .filter((s) => s.length > 0)
}
